var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pa-10 d-flex flex-column gap-4" },
    [
      _c(
        "div",
        { staticClass: "d-flex gap-2 items-center" },
        [
          _c("v-icon", { staticClass: "pr-2", attrs: { color: "error" } }, [
            _vm._v("mdi-alert"),
          ]),
          _c("h2", [_vm._v(_vm._s(_vm.$t("demo.demoError.title")))]),
        ],
        1
      ),
      _c("p", { staticClass: "text-body-1 mt-4" }, [
        _vm._v(" " + _vm._s(_vm.displayErrorMessage) + " "),
        _c("br"),
        _c(
          "span",
          { staticClass: "text-sm-body-2 text--secondary text--lighten-3" },
          [_vm._v(" " + _vm._s(_vm.error.code) + " ")]
        ),
      ]),
      _c(
        "BtnSquare",
        { attrs: { preset: "default" }, on: { click: _vm.tryAgain } },
        [_vm._v(" " + _vm._s(_vm.$t("demo.demoError.buttonLabel")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }